import { useMemo } from "react";
import { useSelector } from "react-redux";
import { IsBbbUseInLessons } from "./IsBbbUseInLessons";

interface RootState {
  settings: {
    bigBlueButtonIntegrationEnabled: string;
    bigBlueButtonIntegrationCanBeUsedInSeparateLessons: string;
  };
}

export const useIsBbbCanBeUsedInSeparateLessons = (): boolean => {
  const isBbbUseInLessons:boolean = IsBbbUseInLessons();
  const bbbEnabled = useSelector((store: RootState) => 
    store.settings.bigBlueButtonIntegrationEnabled === '1'
  );
  
  const isBbbCanBeUsedInLessons = useSelector((store: RootState) => 
    store.settings.bigBlueButtonIntegrationCanBeUsedInSeparateLessons === '1'
  );
  
  const canUseBbb = useMemo(() => bbbEnabled && isBbbCanBeUsedInLessons && !isBbbUseInLessons, [bbbEnabled, isBbbCanBeUsedInLessons, isBbbUseInLessons]);

  return canUseBbb;
}